import { fetch } from '@/utils/http'

export default {
  //多方安全计算
  formGenerate: params => fetch('post', '/encrypt/mpc/generate', params), //生成密钥
  formEncrypt: (url, params) => fetch('post', url, params), //加密计算
  formDecrypt: (url, params) => fetch('post', url, params), //解密计算

  //属性加密
  formSysPubkey: (url, params) => fetch('get', url, params), //获取系统公钥


  formAttrcenterGenerate: (url, params) => fetch('post', url, params), //属性中心生成密钥
  formAttrcenterPubkey: (url, params) => fetch('get', url, params), //获取属性中心公钥
  formUserGenerate: (url, params) => fetch('post', url, params), //生成用户密钥
  formAttrEncrypt: (url, params) => fetch('post', url, params), //加密计算
  formAttrDecrypt: (url, params) => fetch('post', url, params), //解密计算



  //密文检索
  formGencipher:  (url, params) => fetch('post', url, params), //生成密钥

  formIndex: (url, params) => fetch('post', url, params), //生成索引
  formTrap: (url, params) => fetch('post', url, params), //生成陷门
  formSearch: (url, params) => fetch('post', url, params), //搜索



  encryptSvrDownload: params => fetch('post', '/cbaas-service/v1/extra/encryptSvrDownload', params), //搜索

  encryptConfigList: params => fetch('get', '/cbaas-service/v1/extra/encryptConfigList', params), //获取服务器列表

  encryptConfigAdd: params => fetch('post', '/cbaas-service/v1/extra/encryptConfigAdd', params), //添加服务器列表

  encryptConfigModify: params =>
    fetch('post', '/cbaas-service/v1/extra/encryptConfigModify', params), //修改服务器列表

  encryptConfigDel: params => fetch('post', '/cbaas-service/v1/extra/encryptConfigDel', params) //删除服务器列表
}
